import React from 'react';

import { useFundingRound } from '../context/FundingRoundContext';

import styles from './FundingRoundSummary.module.css';

const FundingRoundSummary = () => {

    const { data, isLoading } = useFundingRound();

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>Total Focus Reserved</h3>
            {isLoading ? (
                <div className={styles.loading}>Loading...</div>
            ) : data ? (
                <>
                    <h2 className={styles.totalUSD}>
                        {((data.AmountRaisedUSDCents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }))}
                    </h2>
                    <div className={styles.totalDESO}>
                        {(data.AmountRaisedDesoNanos / 1e9).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DESO
                    </div>
                    <div className={styles.note}>
                        Exchange Rate based on OpenFund data: <strong>${((data.AmountRaisedUSDCents / 100) / (data.AmountRaisedDesoNanos / 1e9)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong> per DESO
                    </div>
                </>
            ) : (
                <div className={styles.noData}>No data available</div>
            )}
        </div>
    );
};

export default FundingRoundSummary;




// import React, { useState, useEffect } from 'react';
// import { fetchFundingRounds } from '../utils/openfund-api';

// import styles from './FundingRoundSummary.module.css';

// const FundingRoundSummary = ({ username }) => {
//     const [data, setData] = useState(null);

//     useEffect(() => {
//         const loadData = async () => {
//             const fundingRounds = await fetchFundingRounds(username);
//             if (fundingRounds && fundingRounds.length > 0) {
//                 setData(fundingRounds[0]); // Assuming you want the first round's data
//             }
//         };
//         loadData();
//     }, [username]);

//     if (!data) {
//         return <div className={styles.container}><span>Loading...</span></div>;
//     }

//     const amountRaisedUSD = data.AmountRaisedUSDCents / 100;
//     const amountRaisedDeso = data.AmountRaisedDesoNanos / 1e9;
//     const exchangeRate = amountRaisedUSD / amountRaisedDeso; // USD per DESO

//     return (
//         <div className={styles.container}>
//             <h3 className={styles.title}>Total Focus Reserved</h3>
//             <div>
//                 <h2 className={styles.totalUSD}>
//                     {amountRaisedUSD.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
//                 </h2>
//                 <div className={styles.totalDESO}>{amountRaisedDeso.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DESO</div>
//                 <div className={styles.note}>Exchange Rate based on OpenFund data: <strong>${exchangeRate.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong> per DESO</div>
//             </div>
//         </div>
//     );
// };

// export default FundingRoundSummary;
